import { Link } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";
import { Chip, Placeholder } from "./Hero";


const Wrap = ({ id, className = "", children }) => <section id={id} className={`max-w-[1200px] mx-auto px-5 sm:px-8 ${className}`}>{children}</section>;
const H2 = ({ children, className = "" }) => <h2 className={`text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.08] text-[#16294A] ${className}`}>{children}</h2>;
const Lbl = ({ children }) => <div className="text-[11px] font-bold text-[#16294A] mt-2">{children}</div>;

export function TagsSection() {
  const cards = [["card_red", "Red · front"], ["card_white", "White · front"], ["card_navy", "Navy · front"], ["card_back", "Back · all cards"]];
  const snaps = [["snap_navy", "NAVY"], ["snap_red", "RED"], ["snap_black", "BLACK"], ["snap_teal", "TEAL"]];
  return (
    <Wrap id="tags" className="pb-20">
      <div data-testid="tags-showcase">
        <Chip>Wallet cards & wristbands</Chip>
        <div className="mt-4 grid lg:grid-cols-[1.4fr_1fr] gap-6 items-end">
          <H2>One tap or one scan. Every tag works both ways.</H2>
          <p className="text-sm text-slate-600 lg:pb-2">Each card and band has its own NFC chip and QR code, linked to one bsafe profile.</p>
        </div>
        <div className="mt-10 text-xs font-extrabold tracking-[0.15em] text-[#16294A]">WALLET CARDS</div>
        <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-4">{cards.map(([s, l]) => (
          <div key={s}><img src={`/landing/${s}.webp`} alt={`bsafe wallet card ${l}`} className="w-full rounded-xl shadow-md lift" /><Lbl>{l}</Lbl></div>))}</div>
        <div className="mt-10 text-xs font-extrabold tracking-[0.15em] text-[#16294A]">WRISTBANDS</div>
        <div className="mt-3 grid lg:grid-cols-[2.6fr_1fr] gap-4">
          <div className="rounded-3xl bg-[#F2F4F8] p-4">
            <div className="grid sm:grid-cols-2 gap-3">{snaps.map(([s, l]) => (
              <div key={s} className="bg-white rounded-2xl p-3"><div className="text-[10px] font-bold text-slate-500 mb-2">{l}</div><img src={`/landing/${s}.webp`} alt={`${l} snap strap`} className="w-full" /></div>))}</div>
            <Lbl>Snap strap · navy, red, black, teal</Lbl>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
            <div><img src="/landing/wide_orange.webp" alt="Orange wide band" className="w-full lift" /><Lbl>Wide band · orange</Lbl></div>
            <div><img src="/landing/wide_sky.webp" alt="Sky blue wide band" className="w-full lift" /><Lbl>Wide band · sky blue</Lbl></div>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          <Link to="/shop" data-testid="order-card-btn" className="rounded-full bg-[#D7263D] hover:bg-[#B51F33] text-white font-bold text-sm px-5 py-2.5 transition-colors">Order a card or band</Link>
          <Link to="/sign-up" data-testid="bulk-orders-btn" className="rounded-full border border-slate-300 text-[#16294A] font-bold text-sm px-5 py-2.5 hover:border-[#16294A] transition-colors">Bulk orders for groups</Link>
        </div>
      </div>
    </Wrap>
  );
}

const Product = ({ img, ph, t, d, to = "/shop", tone = "bg-[#F2F4F8]" }) => (
  <Link to={to} className="bg-white rounded-3xl p-3 lift block" data-testid={`shop-item-${t.split(" ")[0].toLowerCase()}`}>
    {img ? <div className={`rounded-2xl ${tone} h-32 flex items-center justify-center overflow-hidden`}><img src={img} alt={t} className="max-h-full w-auto" /></div>
      : <Placeholder label={ph} className="rounded-2xl h-32" tone={`${tone} text-slate-500`} />}
    <div className="mt-3 px-1 font-bold text-sm text-[#16294A]">{t}</div><div className="px-1 pb-1 text-[11px] text-slate-500">{d}</div>
  </Link>
);

export function ShopSection() {
  return (
    <section id="shop" className="bg-[#F2F4F8] py-20" data-testid="shop-section">
      <Wrap>
        <div className="flex items-end justify-between"><H2>Wear it. Carry it.</H2><Link to="/shop" className="text-sm font-bold text-[#D7263D] underline" data-testid="shop-all-link">Shop all →</Link></div>
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-3">
          <Link to="/shop?c=solid" className="row-span-2 rounded-3xl bg-[#D7263D] p-4 text-white flex flex-col lift" data-testid="shop-item-solid">
            <div className="text-[10px] font-extrabold tracking-widest">BESTSELLER</div>
            <div className="mt-3 bg-white rounded-2xl flex-1 flex items-center justify-center overflow-hidden min-h-[180px]"><img src="/landing/loop_red.webp" alt="Solid colour bands" className="max-h-64 w-auto" /></div>
            <div className="mt-4 text-xl font-extrabold leading-tight">Solid colour bands</div><div className="text-xs opacity-90 mt-1">Silicone, waterproof, NFC + QR · from UGX [0]</div>
          </Link>
          <Product to="/shop?c=solid" img="/landing/snap_navy.webp" t="Snap wristbands" d="Adjustable, NFC + QR · from UGX [0]" />
          <Product to="/shop?c=wallet" img="/landing/card_red.webp" t="Wallet cards" d="Bank-card size · from UGX [0]" tone="bg-[#FCE4E7]" />
          <Product to="/shop?c=apparel" img="/landing/tee_front.webp" t="Apparel" d="Tees, caps, vests · from UGX [0]" />
          <Product to="/shop?c=egift" img="/landing/egift_card.webp" t="eGift card" d="Give peace of mind · from UGX [0]" tone="bg-[#FDF1DE]" />
        </div>
      </Wrap>
    </section>
  );
}

export function PrivacySection() {
  const pts = [["Critical info only.", "Blood group, allergies and contacts are shown. The rest stays private."],
    ["Next-of-kin PIN.", "Full history unlocks only with a PIN from your family's app."],
    ["Every view logged.", "You're told whenever your profile is opened, and a lost tag can be switched off."]];
  return (
    <Wrap id="privacy" className="py-20">
      <div className="grid lg:grid-cols-2 gap-10 items-center" data-testid="privacy-section">
        <div className="relative rounded-3xl overflow-hidden h-72 sm:h-80 bg-[#2C3E66]">
          <img src="/landing/photo_responder.webp" alt="Responder holding a phone showing the bsafe profile" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute left-4 bottom-4 bg-white rounded-2xl p-4 shadow-xl max-w-[240px]">
            <div className="text-[10px] font-extrabold tracking-widest text-[#D7263D]">ALLERGIES · DO NOT GIVE</div>
            <div className="font-extrabold text-[#16294A] mt-1">[Allergy]</div>
            <div className="mt-2 flex items-center gap-2 rounded-lg bg-[#F2F4F8] p-2 text-[11px] text-[#16294A]"><Lock size={14} className="text-amber-600" weight="fill" />More details unlock with next-of-kin PIN</div>
          </div>
        </div>
        <div>
          <span className="rounded-full bg-[#E3E8F5] text-[#16294A] text-xs font-bold px-3 py-1">Privacy & security</span>
          <H2 className="mt-4">Responders see what saves lives. Nothing more.</H2>
          <div className="mt-6 space-y-4">{pts.map(([b, t], i) => (
            <div key={b} className="flex gap-3 text-sm text-slate-600"><span className="w-7 h-7 shrink-0 rounded-lg bg-[#FBE3E6] text-[#D7263D] font-extrabold flex items-center justify-center text-xs">{i + 1}</span><p><b className="text-[#16294A]">{b}</b> {t}</p></div>))}</div>
          <a href="#privacy" className="mt-6 inline-block text-sm font-bold text-[#D7263D] underline" data-testid="data-safe-link">How we keep your data safe →</a>
        </div>
      </div>
      <div id="partners" className="mt-20 border-y border-slate-200 py-8 text-center" data-testid="trusted-by">
        <div className="text-[11px] font-extrabold tracking-[0.25em] text-[#16294A]">TRUSTED BY</div>
        <div className="mt-4 flex flex-wrap justify-center gap-3">{[1, 2, 3, 4, 5].map((i) => <div key={i} className="rounded-xl bg-[#F2F4F8] text-slate-500 text-xs px-6 py-3">[Partner logo]</div>)}</div>
      </div>
    </Wrap>
  );
}

export function CtaSection() {
  return (
    <section className="px-3 sm:px-8 pb-16"><div className="max-w-[1260px] mx-auto relative rounded-[32px] bg-[#2C3E66] overflow-hidden min-h-[300px] flex items-center p-6 sm:p-10" data-testid="cta-section">
      <img src="/landing/photo_kampala.webp" alt="Busy Kampala street" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#16294A]/80 to-transparent" />
      <div className="relative rounded-3xl bg-[#D7263D] p-8 max-w-md text-white">
        <h2 className="text-3xl font-extrabold leading-tight">Every second counts. Get yours today.</h2>
        <div className="mt-6 flex gap-2">
          <Link to="/sign-up" data-testid="cta-join-free-btn" className="rounded-full bg-white border-2 border-white text-[#D7263D] font-bold text-sm px-5 py-2.5">Join free</Link>
          <Link to="/shop" data-testid="cta-shop-tags-btn" className="rounded-full border-2 border-white font-bold text-sm px-5 py-2.5">Shop tags</Link>
        </div>
      </div>
    </div></section>
  );
}


